(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["patimoro-cross-sell"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(card) {
    if (card.dataset.ready) return;
    const form = document.getElementById(card.dataset.form);
    if (!form) return;
    card.dataset.ready = 'true';
    card.hidden = false;
    const check = card.querySelector('[data-cross-check]');
    const extra = card.querySelector('[data-cross-variant]');
    const main = form.querySelector('[name="id"]');
    const buy = form.querySelector('[data-buy]');
    const error = card.querySelector('[data-cross-error]');
    const money = value => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(value / 100);
    const qty = () => Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
    const extraPrice = () => Math.round(Number(extra.selectedOptions[0].dataset.price) * 0.85);
    let busy = false;
    function refresh() {
      card.querySelector('[data-cross-old]').textContent = money(Number(extra.selectedOptions[0].dataset.price));
      card.querySelector('[data-cross-price]').textContent = money(extraPrice());
      card.querySelector('[data-cross-total]').hidden = !check.checked;
      card.querySelector('[data-cross-sum]').textContent = money(Number(main.selectedOptions[0].dataset.price) * qty() + extraPrice());
    }
    form.addEventListener('change', refresh);
    form.addEventListener('submit', async event => {
      if (!check.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || buy.disabled) return;
      busy = true;
      buy.disabled = true;
      error.hidden = true;
      try {
        const response = await fetch(card.dataset.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(main.value), quantity: qty() }, { id: Number(extra.value), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || card.dataset.error);
        window.location.assign(card.dataset.root + 'discount/' + encodeURIComponent(card.dataset.code) + '?redirect=' + encodeURIComponent(card.dataset.cart));
      } catch (err) {
        error.textContent = err.message || card.dataset.error;
        error.hidden = false;
        busy = false;
        buy.disabled = false;
      }
    }, true);
    refresh();
  }
  document.querySelectorAll('[data-cross]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-cross]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["patimoro-glove-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(card) {
    if (card.dataset.ready) return;
    const form = document.getElementById(card.dataset.form);
    if (!form) return;
    card.dataset.ready = 'true';
    card.hidden = false;
    const check = card.querySelector('[data-glove-cross-check]');
    const extra = card.querySelector('[data-glove-cross-variant]');
    const main = form.querySelector('[name="id"]');
    const buy = form.querySelector('[data-buy]');
    const mobile = form.closest('[data-pg]')?.querySelector('[data-mobile-buy]');
    const error = card.querySelector('[data-glove-cross-error]');
    const money = value => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(value / 100);
    const qty = () => Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
    const extraPrice = () => Math.round(Number(extra.selectedOptions[0].dataset.price) * 0.85);
    let busy = false;
    function refresh() {
      card.querySelector('[data-glove-cross-old]').textContent = money(Number(extra.selectedOptions[0].dataset.price));
      card.querySelector('[data-glove-cross-price]').textContent = money(extraPrice());
      card.querySelector('[data-glove-cross-total]').hidden = !check.checked;
      card.querySelector('[data-glove-cross-sum]').textContent = money(Number(main.selectedOptions[0].dataset.price) * qty() + extraPrice());
    }
    form.addEventListener('change', refresh);
    form.addEventListener('submit', async event => {
      if (!check.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || buy.disabled) return;
      busy = true;
      buy.disabled = true;
      if (mobile) mobile.disabled = true;
      error.hidden = true;
      try {
        const response = await fetch(card.dataset.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(main.value), quantity: qty() }, { id: Number(extra.value), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || card.dataset.error);
        window.location.assign(card.dataset.root + 'discount/' + encodeURIComponent(card.dataset.code) + '?redirect=' + encodeURIComponent(card.dataset.cart));
      } catch (err) {
        error.textContent = err.message || card.dataset.error;
        error.hidden = false;
        busy = false;
        buy.disabled = false;
        if (mobile) mobile.disabled = false;
      }
    }, true);
    refresh();
  }
  document.querySelectorAll('[data-glove-cross]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-glove-cross]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["patimoro-launcher-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(card) {
    if (card.dataset.ready) return;
    const form = document.getElementById(card.dataset.form);
    const rows = Array.from(card.querySelectorAll('[data-offer-item]'));
    if (!form || !rows.length) return;
    card.dataset.ready = 'true';
    card.hidden = false;
    const root = card.dataset.root.replace(/\/?$/, '/');
    const main = form.querySelector('[name="id"]');
    const buy = form.querySelector('[data-buy]');
    const error = card.querySelector('[data-offer-error]');
    const money = value => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(value / 100);
    const qty = () => Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
    const selected = () => rows.filter(row => row.querySelector('[data-offer-check]').checked);
    const variant = row => row.querySelector('[data-offer-variant]');
    const discounted = row => Math.round(Number(variant(row).selectedOptions[0].dataset.price) * 0.85);
    const codes = { glove: 'PATIMORO-TOP-ELDIVEN15', duck: 'PATIMORO-TOP-ORDEK15', both: 'PATIMORO-TOP-IKILI15' };
    let busy = false;
    function refresh() {
      rows.forEach(row => {
        row.querySelector('[data-offer-old]').textContent = money(Number(variant(row).selectedOptions[0].dataset.price));
        row.querySelector('[data-offer-price]').textContent = money(discounted(row));
      });
      const extras = selected();
      card.querySelector('[data-offer-total]').hidden = !extras.length;
      card.querySelector('[data-offer-sum]').textContent = money(Number(main.selectedOptions[0].dataset.price) * qty() + extras.reduce((sum, row) => sum + discounted(row), 0));
    }
    form.addEventListener('change', refresh);
    form.addEventListener('submit', async event => {
      const extras = selected();
      if (!extras.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || buy.disabled) return;
      busy = true;
      buy.disabled = true;
      error.hidden = true;
      const code = codes[extras.length === 2 ? 'both' : extras[0].dataset.key];
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(main.value), quantity: qty() }, ...extras.map(row => ({ id: Number(variant(row).value), quantity: 1 }))] })
        });
        const result = await response.json().catch(() => { throw new Error(card.dataset.error); });
        if (!response.ok) throw new Error(result.description || card.dataset.error);
        window.location.assign(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(card.dataset.cart));
      } catch (err) {
        error.textContent = err.message || card.dataset.error;
        error.hidden = false;
        busy = false;
        buy.disabled = false;
      }
    }, true);
    refresh();
  }
  document.querySelectorAll('[data-launcher-offer]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-launcher-offer]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

})();
